import { permissions } from '../../constants';
import { ReportItem } from './types/ReportItem';

export enum ReportType {
    NotSelected = '',
    CourierDetails = 'courier-detail',
    OrderStatus = 'order-status',
    FreelancerCouriers = 'freelancer-couriers',
    NewAddressRegistry = 'new-addresses-registry',
    ReportOnRegisteredRpo = 'report-on-registered-rpo',
    ReceiptRequestReport = 'receipt-request-report',
    ReceivedCourierDetail = 'received-courier-detail',
    ReportOnSubdivisions = 'report-on-subdivisions',
    ReportOnCheque = 'report-on-cheque',
    ReportOnPension = 'report-on-completed-uncompleted-pension',
    ReportOnCompletedPayment = 'completed-mobile-payment',
    NPO = 'npo',
    ReportOnDeliveryAddress = 'import-rpo-excel',
}
export const reportTypes: ReportItem[] = [
    {
        url: ReportType.CourierDetails,
        name: 'Отчет по выданным на доставку отправлениям',
        permissions: [
            permissions.Admin,
            permissions.Operator,
            permissions.PensionOperator,
            permissions.Dispatcher,
            permissions.Coordinator,
        ],
    },
    {
        url: ReportType.ReportOnCompletedPayment,
        name: 'Отчет по платежам',
        permissions: [
            permissions.Admin,
            permissions.Operator,
            permissions.PensionOperator,
            permissions.Dispatcher,
            permissions.Coordinator,
        ],
    },
    {
        url: ReportType.OrderStatus,
        name: 'Отчет по статусам',
        permissions: [
            permissions.Admin,
            permissions.Operator,
            permissions.PensionOperator,
            permissions.Dispatcher,
            permissions.Coordinator,
        ],
    },
    {
        url: ReportType.NewAddressRegistry,
        name: 'Отчет по отправлениям с некорректными адресами',
        permissions: [
            permissions.Admin,
            permissions.Operator,
            permissions.PensionOperator,
            permissions.Dispatcher,
            permissions.Coordinator,
        ],
    },
    {
        url: ReportType.ReportOnRegisteredRpo,
        name: 'Отчет по зарегистрированным (принятым) отправлениям',
        permissions: [
            permissions.Admin,
            permissions.Operator,
            permissions.PensionOperator,
            permissions.Dispatcher,
            permissions.Coordinator,
        ],
    },
    {
        url: ReportType.ReceiptRequestReport,
        name: 'Отчет по заявкам на вызов курьера',
        permissions: [
            permissions.Admin,
            permissions.Operator,
            permissions.PensionOperator,
            permissions.Dispatcher,
            permissions.Coordinator,
        ],
    },
    {
        url: ReportType.ReceivedCourierDetail,
        name: 'Отчет по входящим EMS отправлениям',
        permissions: [
            permissions.Admin,
            permissions.Operator,
            permissions.PensionOperator,
            permissions.Dispatcher,
            permissions.Coordinator,
        ],
    },
    {
        url: ReportType.FreelancerCouriers,
        name: 'Отчет по внештатным курьерам',
        permissions: [permissions.Admin, permissions.HR, permissions.Coordinator],
    },
    {
        url: ReportType.ReportOnSubdivisions,
        name: 'Отчет по подразделениям',
        permissions: [
            permissions.Admin,
            permissions.Operator,
            permissions.PensionOperator,
            permissions.Dispatcher,
            permissions.Coordinator,
        ],
    },
    {
        url: ReportType.ReportOnCheque,
        name: 'Отчет по чекам',
        permissions: [
            permissions.Admin,
            permissions.Operator,
            permissions.PensionOperator,
            permissions.Dispatcher,
            permissions.Coordinator,
        ],
    },
    {
        url: ReportType.ReportOnPension,
        name:
            'Отчет по выплаченным и не выплаченным суммам пенсий и пособий по спискам ведомостям формы 7Д',
        permissions: [
            permissions.Admin,
            permissions.Operator,
            permissions.PensionOperator,
            permissions.Dispatcher,
            permissions.Coordinator,
        ],
    },
    {
        url: ReportType.ReportOnDeliveryAddress,
        name: 'Отчет по адресам доставки в разрезе номеров РПО',
        permissions: [
            permissions.Admin,
            permissions.Operator,
            permissions.PensionOperator,
            permissions.Dispatcher,
            permissions.Coordinator,
        ],
    },
    {
        url: ReportType.NPO,
        name: 'Отчет по НПО',
        permissions: [
            permissions.Admin,
            permissions.Operator,
            permissions.PensionOperator,
            permissions.Dispatcher,
            permissions.Coordinator,
        ],
    },
];
